module.exports = __webpack_public_path__ + "static/img/albums_g.ff016bb8.png";